import Component from '../abstracts/Component';

export default class GlobalMessagesComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-global-alert',
      cartMsg: '.cart-listing .js-global-alert'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      hide: 'hide'
    };
  }

  constructor() {
    super();
    this.mainTarget = $(this.SELECTORS.main);
    this.cartMsg = $(this.SELECTORS.cartMsg);
  }


  bindEvents() {

    this.cartMsg.addClass(this.CLASSES.show);
    setTimeout(() => {
      this.cartMsg.removeClass(this.CLASSES.show);
    }, 3000)

  }

  render() {
    this.bindEvents();
  }
}
